import React, { useEffect, useState } from "react";
import NumberedHeading from "../components/NumberedHeading";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../../utils/recoil";
import config from "../../../config";
import { useTranslation } from "react-i18next";

const Overview = () => {
  const { t } = useTranslation("result");
  const [data] = useRecoilState(detailedResultState);
  const [population, setPopulation] = useState({
    total_percent: 1,
    men_percent: 1,
    women_percent: 1,
    mbti_id: 1,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.nodeDomain}/result/population?mbti_id=${data?.mbti_type_id}`
        );
        const json = await response.json();
        setPopulation(json.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [data]);

  return (
    <div className="px-[10rem] md-max:px-[1rem] md-max:flex md-max:flex-col md-max:gap-4 md-max:mt-10">
      <NumberedHeading
        number={"1"}
        title={t("overview.title")}
        className={"-translate-y-full md-max:translate-y-0"}
      />

      <p className="text-xl md-max:text-base !leading-[32px]">{data?.overview}</p>

      <div className="grid grid-cols-3 gap-6 max-w-[80%] md-max:max-w-full mt-10 mx-auto md-max:mx-0 md-max:grid-cols-1">
        <div className="bg-primary-blue/10 rounded-2xl h-[10rem] md-max:h-[8rem] flex flex-col justify-center items-center">
          <p className="font-semibold text-primary-blue text-[2.5rem] md-max:text-3xl">
            {population?.total_percent}%
          </p>
          <p className="text-xl md-max:text-lg">{t("overview.population")}</p>
        </div>
        <div className="bg-primary-blue/10 rounded-2xl h-[10rem] md-max:h-[8rem] flex flex-col justify-center items-center">
          <p className="font-semibold text-primary-blue text-[2.5rem] md-max:text-3xl">
            {population?.men_percent}%
          </p>
          <p className="text-xl md-max:text-lg">{t("overview.men")}</p>
        </div>
        <div className="bg-primary-blue/10 rounded-2xl h-[10rem] md-max:h-[8rem] flex flex-col justify-center items-center">
          <p className="font-semibold text-primary-blue text-[2.5rem] md-max:text-3xl">
            {population?.women_percent}%
          </p>
          <p className="text-xl md-max:text-lg">{t("overview.women")}</p>
        </div>
      </div>
    </div>
  );
};

export default Overview;
